/* eslint-disable no-undef */
import React, { useEffect, useState,useMemo } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ContainerMain, BrandingTabContainer, BrandingTab } from '../common/commonStyles';
import SnapShot from './snapshot'
import Analyctics from './analytics'
import Insights from './insight'
import Performance from './performance'
import HoverButton from '../common/HoverButton'
import { AdminDownloadIcon, AdminFilterIcon, AdminSettingIcon, AdminCompareIcon, ProductTourIcon, DownloadIcon } from '../../utils/icons'
import { ComparisonStyledModal, WrapperYear, YearDataComparisonCard } from "../Recognition/styles";
import { Modal } from "react-bootstrap";
import { NewActivityDropdownCommon } from '../common/CommonDropDown/style';
import { Dropdown } from "react-bootstrap";
import { DropdownArrow, CloseIconBranding, AddIconBranding } from "../../utils/icons";
import { ImageUrl } from "../../utils/constants";
import { ModalTitle, Border, DropdownHeading } from './styles'
import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';
import DownloadReportsModal from './DownloadReportsModal';
import Anniversaries from './anniversaries';
import Library from './library';
import ManageAniBiPopup from './corevalues/ManageAniBiPopup';
import DeptLoc from '../common/CommonDeptLoc/DeptLoc';
import { toast } from "react-toastify";
import { cleanUpCommas, fetchApi } from "../../utils/methods";
import { GetRecognitionOverviewComparison, GetTopTenAndLowTenPerformingUsers, GetMostRecognitionGivenUsers, GetMostRecognitionReceivedUsers, GetRecognitionOverview, GetSocialFeedSnapshot, GetCelebrations, GetPerformanceReport, GetInsightReport, /*GetUserProductTourDetails*/ } from "../../redux/constants/apiConstants";
const filterOption = ["Monthly", "Quarterly", "Yearly"];
const monthOption = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const quarterlyOptions = ["Jan-Mar", "Apr-Jun", "Jul-Sep", "Oct-Dec"];
// const yearlyOptions = ["2025", "2024", "2023"];
const anniversaryFilterOptions = ["Monthly", "Quarterly"];
import { GetDepartmentAnylytics, GetLocationAnylytics } from '../../redux/constants/apiConstants';
import Walkthrough from "./Driver/SnapShotDriver";
import ExcelJS from 'exceljs/dist/exceljs';
import { useSelector } from "react-redux";
import moment from 'moment';

const RecognitionMain = ({ /*companyBrandingDetails,*/ history, yearList, companyInfo,departmentDetails, locationDetails,  productTourDetails }) => {
  // const getCurrentQuarter =()=> {
  //   const month = new Date().getMonth() + 1; // Get 1-based month (1 = Jan, 2 = Feb, ...)

  //   if (month >= 1 && month <= 3) return "q1";
  //   if (month >= 4 && month <= 6) return "q2";
  //   if (month >= 7 && month <= 9) return "q3";
  //   return "44"; // Months 10-12
  // }
  let date = new Date();
  const DownloadIconHide = false;
  // const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  // const currentMonth = new Date().getMonth() + 1;
  // const currentQuarter= getCurrentQuarter();
  date.setFullYear(date.getFullYear() - 1);
  // const [activeTab, setActiveTab] = useState(history.location?.state?.activeTab?history.location?.state?.activeTab:1);
  const [activeTab, setActiveTab] = useState(1);
  const [isComparisonModal, handleComparisonModal] = useState(false);
  const [isReportsDownloadModal, handleReportsDownloadModal] = useState(false);
  const [comparisonFromYear, getComparisonFromYear] = useState(new Date().getFullYear())
  const [comparisonToYear, getComparisonToYear] = useState(date.getFullYear())
  const [filterOptions, setFilterOptions] = useState(filterOption);
  const [filterOptionsName, setFilterOptionsName] = useState(monthOption);
  const [showManageAniBiPopup, setShowManageAniBiPopup] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [pageNumberReceived, setPageNumberReceived] = useState(1);
  const [pageNumberGiven, setPageNumberGiven] = useState(1);

  const [timeInterval, setTimeInterval] = useState(monthOption[new Date().getMonth()]);
  const [monthInterval, setMonthInterval] = useState(monthOption[new Date().getMonth()]);
  // const [monthOptions, setMonthOptions] = useState(monthOption);
  // const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedYear, setSelectedYear] = useState(moment().format("YYYY"));


  // const yearOptions = ["2025", "2024", "2023"];
  const [compareYearData, setcompareYearData] = useState([]);
  const [topLowPerformingUsers, setTopLowPerformingUsers] = useState([]);
  const [geRecognitionGivenUsers, setRecognitionGivenUsers] = useState([]);
  const [getRecognitionReceivedUsers, setRecognitionReceivedUsers] = useState([]);
  const [getRecognitionOverview, setRecognitionOverview] = useState([]);
  const [getInsightUser, setInsightUser] = useState('employee');
  const [topCardsAndGraph, getTopCardsAndGraph] = useState([]);
  const [monthlyBreakDown, getmonthlyBreakDown] = useState([]);
  const [topPerformingEmployee, setTopPerformingEmployee] = useState([]);
  const [topPerformingManager, setTopPerformingManager] = useState([]);
  const [getRecognitionReceivedUsersData, setRecognitionReceivedUsersData] = useState([]);
  const [geRecognitionGivenUsersData, setRecognitionGivenUsersData] = useState([]);
  const [topThree, setTopThree] = useState([]);
  const [topTotal, setTopTotal] = useState();
  const [topThreeLocation, setTopThreeLocation] = useState([]);
  const [topTotalLocation, setTopTotalLocation] = useState();
  const [topCardsAndGraphLoader, getTopCardsAndGraphLoader] = useState(true);
  const [anniversaryData, setAnniversaryData] = useState([]);
  const [activeSubTab, setActiveSubTab] = useState('anniversary');
  const [showWalkthrough, setShowWalkthrough] = useState(false);

  const companyDetails = useSelector((state) => state.profileData.companyDetails);

  const yearOptions = useMemo(() => {
    if (!companyDetails?.company_start_date) return [];

    const startYear = companyDetails?.company_start_date; // e.g. 2016
    const currentYear = new Date().getFullYear(); // e.g. 2025
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push(year.toString());
    }

    return years.slice(0, 3);
    // return years;
  }, [companyDetails]);
  

  const limit = 5;
  const setPageNumberPaginationReceived = (value) => {
    let type = timeInterval === "Monthly" ? "month" : timeInterval === "Quarterly" ? "quarter" : "year";
    let index = timeInterval === "Monthly" ? monthOption.indexOf(monthInterval) + 1 : timeInterval === "Quarterly" ? quarterlyOptions.indexOf(monthInterval) + 1 : monthInterval;
    setPageNumberReceived(value)
    fetchMostRecognitionReceivedUsers(getInsightUser, companyInfo?.id, type, timeInterval === "Quarterly" ? `q${index}` : index, value, 7)
  }

  const setPageNumberPaginationGiver = (value) => {
    setPageNumberGiven(value)
    fetchMostRecognitionGivenUsers(getInsightUser, companyInfo?.id, 'year', selectedYear, value, 6)
  }

  useEffect(() => {
    if (history.location.state) {
      setActiveTab(history.location.state.activeTab)
    }
    if (activeTab === 3) {
      fetchInsightTabAPI(getInsightUser, companyInfo?.id, 'year', currentYear)
    }
    fetchTopCardsAndGraph(selectedYear)
    fetchTopAndLowPerformingEmployee('employee', companyInfo?.id, 'year', selectedYear, limit)
    fetchTopAndLowPerformingManager('manager', companyInfo?.id, 'year', selectedYear, limit)
  }, [])



  useEffect(()=>{
    fetchTopAndLowPerformingEmployee('employee', companyInfo?.id, 'year', selectedYear, limit)
    fetchTopAndLowPerformingManager('manager', companyInfo?.id, 'year', selectedYear, limit)
  },[selectedYear]);


  const fetchPerformanceReport = async()=>{

    const endpoint = GetPerformanceReport + "/" + companyInfo?.id + "/" + new Date().getFullYear() + "/" + (timeInterval === "Monthly" ? "month" : timeInterval === "Quarterly" ? "quarter" : "year");
    const res = await fetchApi(endpoint);
    exportRecognitionReportMonthWise(res?.data)
  
  }

  const fetchInsightsReport = async()=>{

    let index = timeInterval === "Monthly" ? monthOption.indexOf(monthInterval) + 1 : timeInterval === "Quarterly" ? quarterlyOptions.indexOf(monthInterval) + 1 : monthInterval;

    let value;

    if (timeInterval === "Monthly") {
      value=index
    }
    else if (timeInterval === "Quarterly") {
      value = `q${index}`
    }
    else {
      value = selectedYear;
    }

    const endpoint = GetInsightReport + "/" + getInsightUser + "/" + companyInfo?.id + "/"  + (timeInterval === "Monthly" ? "month" : timeInterval === "Quarterly" ? "quarter" : "year") + "/" + value;
    const res = await fetchApi(endpoint);
    window.console.log("res",res);
    exportInsightReport(res?.data)
  
  }

  const exportInsightReport = (data) => {
    const workbook = new ExcelJS.Workbook();
  
    Object.entries(data).forEach(([key, value]) => {
      // Skip if value is empty or invalid
      if (!value || (Array.isArray(value) && value?.length === 0)) return;
  
      // Special case: Company Insights
      if (key === "company_insights") {
        const worksheet = workbook.addWorksheet("Company Insights");
  
        const coreValues = value?.core_values?.map((cv) => cv?.core_value);
  
        worksheet.columns = [
          { header: "User ID", key: "user_id", width: 10 },
          { header: "User Name", key: "user_name", width: 30 },
          { header: "Department", key: "department", width: 20 },
          { header: "Location", key: "location", width: 20 },
          ...coreValues.map((cv) => ({ header: cv, key: cv, width: 20 })),
          { header: "Total", key: "total_recognition_count", width: 20 },
        ];
  
        value.user.forEach((user) => {
          const row = {
            user_id: user?.user_id,
            user_name: user?.user_name,
            department: user?.department || "N/A",
            location: cleanUpCommas(user?.location) || "N/A",
          };
  
          // Fill in recognition counts by core value
          user?.core_values?.forEach((cv) => {
            row[cv.core_value] = cv?.recognition_count;
          });
          row["total_recognition_count"] = user?.total_recognition_count
  
          worksheet.addRow(row);
        });
  
        worksheet.getRow(1).font = { bold: true };
        worksheet.eachRow((row) => {
          row.alignment = { vertical: "middle", horizontal: "left", indent: 1 };
        });
  
      } else {
        // For all other sheets dynamically
        const worksheet = workbook.addWorksheet(
          key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize words
        );
  
        worksheet.columns = [
          { header: "User ID", key: "user_id", width: 10 },
          { header: "User Name", key: "user_name", width: 30 },
          { header: "Department", key: "department", width: 20 },
          { header: "Location", key: "location", width: 20 },
          { header: "Recognition Count", key: "recognition_count", width: 20 },
        ];
  
        value.forEach((user) => {
          worksheet.addRow({
            user_id: user.user_id,
            user_name: user.user_name,
            department: user.department || "N/A",
            location: cleanUpCommas(user.location) || "N/A",
            recognition_count: user.recognition_count,
          });
        });
  
        worksheet.getRow(1).font = { bold: true };
        worksheet.eachRow((row) => {
          row.alignment = { vertical: "middle", horizontal: "left", indent: 1 };
        });
      }
    });
  
    // Export the Workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Recognition-Insights-Report-${timeInterval}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  

  const exportRecognitionReportMonthWise = (data) => {
    
    const workbook = new ExcelJS.Workbook();
  
    Object.entries(data).forEach(([month, users]) => {
      if (users.length === 0) return;
  
      const worksheet = workbook.addWorksheet(month);
  
      // Define headers
      worksheet.columns = [
        { header: 'User ID', key: 'user_id', width: 10 },
        { header: 'Name', key: 'user_name', width: 30 },
        // { header: 'Profile Image', key: 'profile_image', width: 40 },
        { header: 'Department', key: 'department', width: 25 },
        { header: 'Location', key: 'location', width: 25 },
        { header: 'Recognition Count', key: 'recognition_count', width: 20 },
      ];
  
      // Add rows
      users.forEach((user) => {
        worksheet.addRow({
          user_id: user.user_id,
          user_name: user.user_name,
          profile_image: user.profile_image,
          department: user.department || 'N/A',
          location: cleanUpCommas(user.location) || 'N/A',
          recognition_count: user.recognition_count
        });
        const row = worksheet.lastRow;
        row.alignment = { vertical: 'middle', horizontal: 'left',indent: 1  };
      });
  
      // Make header bold
      worksheet.getRow(1).font = { bold: true };
    });
  
    // Export file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
  
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Recognition-Performance-Report-${timeInterval}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const fetchInsightTabAPI = (role, id, type, value) => {
    fetchTopAndLowPerformingUsers(role, id, type, value)
    fetchMostRecognitionReceivedUsers(role, id, type, value, 1, 7)
    fetchMostRecognitionGivenUsers(role, id, type, value, 1, 7)
    // fetchMostRecognitionGivenUsers()
    // fetchMostRecognitionReceivedUsers()
    getchRecognitionOverview(role, id, type, value)
  }

  const selectYearData = (value) => {
    setSelectedYear(value)
    fetchTopCardsAndGraph(value)
  }

  useEffect(() => {
    fetchCelebrationsDetails();
  }, [timeInterval, activeSubTab])

  useEffect(() => {
    
    if (companyInfo?.id === 1) {
      setShowWalkthrough(productTourDetails?.product_tour_data?.admin_recognition);
    }
    
    
  }, [productTourDetails, companyInfo?.id]);

  const onProductTourClick = ()=>{
    // sendProductTourData()
    handleTabClick(1)
    setShowWalkthrough(true);

  }

  const hideProductTour = ()=>{
    setShowWalkthrough(false);
  }

  // const sendProductTourData = async () => {
  //   const productTourPayload = {
  //     company_id: companyInfo?.id, 
  //     product_tour_data: {
  //       admin_recognition: false,
  //     }
  //   };
  //   try {
  //     const res = await fetchApi(GetUserProductTourDetails,  "POST", productTourPayload);
  //     if(res.status === "success"){
  //       // toast.success(res?.data?.message)
  //       if (this.driver) {
  //         this.driver.destroy();  
  //       }
        
  //     }
  //     else {
  //       toast.error(res?.message?.message)
  //     }
  //   }
  //   catch (error) {
  //     // toast.error(error)
  //   }
  // }

  const fetchCelebrationsDetails = async (departments = [], locations = []) => {
    let company_id = companyInfo.id
    let filter = timeInterval === "Monthly" ? "month" : timeInterval === "Quarterly" ? "quarter" : "month";
    const payload = {
      celebration_type: activeSubTab,
      type: filter,
      departments: departments,
      locations: locations
    }
    let apiUrl = `${GetCelebrations}/${company_id}`;
    try {
      const res = await fetchApi(apiUrl, "Post", payload);

      if (res.status === "success") {
        const formattedData = Object.entries(res.data)
          .filter(([, users]) => users?.length > 0) // Only include non-empty periods
          .map(([period, users]) => ({
            title: period.replace(/\|/g, " | "), // Replace "|" with " | " for better formatting
            headers: ["Employees", "Total"],
            data: users.map((user) => ({
              name: user.user_name,
              total_posts: activeSubTab === "anniversary" ? user.work_anniversary : user.birthday,
              image: user.profile_image,
            })),
          }));
        setAnniversaryData(formattedData)
        if (formattedData.length === 0) {
          if(timeInterval === "Monthly" ){
            const months = [
              "January", "February", "March", "April", "May", "June",
              "July", "August", "September", "October", "November", "December"
            ];
    
            // Initialize data with empty months
            let formattedData = months.map((month) => ({
              title: month,
              headers: ["Employees", "Total"],
              data: [],
            }));
            setAnniversaryData(formattedData);
          }else if(timeInterval === "Quarterly" ){
            const months = [
              "January-March | Q1", "April-June | Q2", "July-September | Q3", "October-December | Q4"
            ];
    
            // Initialize data with empty months
            let formattedData = months.map((month) => ({
              title: month,
              headers: ["Employees", "Total"],
              data: [],
            }));
            setAnniversaryData(formattedData);
          }
        }

      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  const fetchDepartmentAnalyticsDetails = async () => {
    let company_id = companyInfo.id
    let apiUrl = `${GetDepartmentAnylytics}/${company_id}/year/${selectedYear}`;

    // let apiUrl = `${GetDepartmentAnylytics}/1/month/2`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setTopTotal(res.data.total_top_posts)

        const backgroundColors = ["#B1AA56", "#92A4DA", "#DA9B6C"];
        const whiteColors = ["#ffff", "#ffff", "#ffff"];
        const widthSize = [204, 160, 96];

        const processedTopData = res?.data.top_three?.length > 0 && res?.data?.top_three?.map((item, index) => ({
          ...item,
          background: backgroundColors[index] || "#fff",
          color: whiteColors[index] || "#ffff",
          value: item?.total_posts || 0,
          width: widthSize[index] || 0,
        }));

        setTopThree(processedTopData)
        // const textColors = ["#DA92C8", "#C96BAE", "#75B084"];
        // const processedData = res?.data?.low_three?.map((item, index) => ({
        //   color: textColors[index] || "#ffff",
        //   value: item?.total_posts || 0,
        //   category: item?.name || ""
        // }));

        // setLowThree(processedData)
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  const fetchLocationAnalyticsDetails = async () => {
    let company_id = companyInfo.id
    let apiUrl = `${GetLocationAnylytics}/${company_id}/year/${selectedYear}`;
    try {
      const res = await fetchApi(apiUrl, "Get");
      if (res.status === "success") {
        setTopTotalLocation(res.data.total_top_posts)
        const backgroundColors = ["#B1AA56", "#C96BAE", "#75B084"];
        const whiteColors = ["#ffff", "#ffff", "#ffff"];
        const widthSize = [204, 160, 96];

        const processedTopData = res?.data?.top_three?.length > 0 && res?.data?.top_three?.map((item, index) => ({
          ...item,
          background: backgroundColors[index] || "#fff",
          color: whiteColors[index] || "#ffff",
          value: item?.total_posts || 0,
          width: widthSize[index] || 0,
        }));

        setTopThreeLocation(processedTopData)
        // const textColors = ["#DA92C8", "#C96BAE", "#75B084"];
        // const processedData = res?.data?.low_three?.map((item, index) => ({
        //   color: textColors[index] || "#ffff",
        //   value: item?.total_posts || 0,
        //   category: item?.name || ""
        // }));

        // setLowThreeLocation(processedData)
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  useEffect(() => {
    fetchLocationAnalyticsDetails();
    fetchDepartmentAnalyticsDetails();
  }, [selectedYear])

  const fetchTopCardsAndGraph = async (selectedYear) => {
    try {
      const res = await fetchApi(GetSocialFeedSnapshot + "/" + companyInfo?.id + "/" + selectedYear, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        getTopCardsAndGraph(res?.data?.top_4_cards)
        getmonthlyBreakDown(res?.data)
        getTopCardsAndGraphLoader(false)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchcompareYearData = async (comparisonFromYear, comparisonToYear) => {
    try {
      const res = await fetchApi(GetRecognitionOverviewComparison + "/" + companyInfo?.id + "/" + comparisonFromYear + "/" + comparisonToYear, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        setcompareYearData(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchTopAndLowPerformingUsers = async (role, id, type, value) => {
    try {
      const res = await fetchApi(GetTopTenAndLowTenPerformingUsers + "/" + role + "/" + id + "/" + type + "/" + value, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        setTopLowPerformingUsers(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchTopAndLowPerformingEmployee = async (role, id, type, value, limit) => {
    try {
      const res = await fetchApi(GetTopTenAndLowTenPerformingUsers + "/" + role + "/" + id + "/" + type + "/" + value + "/" + limit, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        setTopPerformingEmployee(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchTopAndLowPerformingManager = async (role, id, type, value, limit) => {
    try {
      const res = await fetchApi(GetTopTenAndLowTenPerformingUsers + "/" + role + "/" + id + "/" + type + "/" + value + "/" + limit, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        setTopPerformingManager(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchMostRecognitionGivenUsers = async (role, id, type, value, page, limit) => {
    try {
      const res = await fetchApi(GetMostRecognitionGivenUsers + "/" + role + "/" + id + "/" + type + "/" + value + '/' + page + '/' + limit, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        const response = res?.data
        setRecognitionGivenUsers(response)
        if (page === 1) {
          setRecognitionGivenUsersData([...response.users])
        } else {
          setRecognitionGivenUsersData([...geRecognitionGivenUsersData, ...response.users])
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchMostRecognitionReceivedUsers = async (role, id, type, value, page, limit) => {
    try {
      const res = await fetchApi(GetMostRecognitionReceivedUsers + "/" + role + "/" + id + "/" + type + "/" + value + '/' + page + '/' + limit, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        const response = res?.data
        if (page === 1) {
          setRecognitionReceivedUsersData([...response.users])
        }
        else {
          setRecognitionReceivedUsersData([...getRecognitionReceivedUsersData, ...response.users])
        }
        setRecognitionReceivedUsers(response)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getchRecognitionOverview = async (role, id, type, value) => {
    try {
      const res = await fetchApi(GetRecognitionOverview + "/" + role + "/" + id + "/" + type + "/" + value, "GET");
      if (res?.data?.message) {
        toast.error(res.data.message)
      } else {
        setRecognitionOverview(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }
  };
  
  const ReportsDownloadPopup = () => {
    handleReportsDownloadModal(!isReportsDownloadModal)
  }

  const manageComparisonPopup = () => {
    handleComparisonModal(!isComparisonModal)
  }

  const openComparisonPopup = () => {
    fetchcompareYearData(comparisonToYear, comparisonFromYear)
    handleComparisonModal(!isComparisonModal)
  }

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    // history.push({state:{activeTab:tabIndex, activeTabV: ""}});
    if (tabIndex === 5) {
      setFilterOptions(anniversaryFilterOptions);
      setTimeInterval("Quarterly");
    } else if (tabIndex === 3 || tabIndex === 2) {
      setTimeInterval("Yearly");
      setMonthInterval(new Date().getFullYear());
    }
    else {
      setFilterOptions(filterOption);
      setTimeInterval("Monthly");
    }
    if (tabIndex === 3) {
      fetchInsightTabAPI(getInsightUser, companyInfo?.id, 'year', currentYear)
    }
    if (tabIndex === 1) {
      fetchTopCardsAndGraph(selectedYear);
    }
  };



  const getCurrentQuarter = () => {
    const month = new Date().getMonth(); // Get 1-based month (1 = Jan, 2 = Feb, ...)
    if (month >= 1 && month <= 3) return 0;
    if (month >= 4 && month <= 6) return 1;
    if (month >= 7 && month <= 9) return 2;
    return 3; // Months 10-12
  }


  const handleTimeIntervalChange = (selectedOption) => {
    const currentQuarter = getCurrentQuarter();
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    setTimeInterval(selectedOption);
    setPageNumberReceived(1)
    setPageNumberGiven(1)
    let index = selectedOption === "Monthly" ? monthOption.indexOf(monthOption[currentMonth]) + 1 : selectedOption === "Quarterly" ? quarterlyOptions.indexOf(quarterlyOptions?.[currentQuarter]) + 1 : new Date().getFullYear();
    if (selectedOption === "Monthly") {
      setMonthInterval(monthOption[currentMonth]);
      if (activeTab === 3) {
        fetchInsightTabAPI(getInsightUser, companyInfo?.id, "month", index)
      }
    } else if (selectedOption === "Quarterly") {
      setMonthInterval(quarterlyOptions?.[currentQuarter]);
      if (activeTab === 3) {
        fetchInsightTabAPI(getInsightUser, companyInfo?.id, "quarter", `q${index}`)
      }
    } else {
      setMonthInterval(currentYear);
      if (activeTab === 3) {
        fetchInsightTabAPI(getInsightUser, companyInfo?.id, "year", currentYear)
      }
    }

  };


  const handleMonthNameChange = (selectedOption) => {
    setMonthInterval(selectedOption)
    setPageNumberReceived(1)
    setPageNumberGiven(1)
    let index = timeInterval === "Monthly" ? monthOption.indexOf(selectedOption) + 1 : timeInterval === "Quarterly" ? quarterlyOptions.indexOf(selectedOption) + 1 : selectedOption;

    if (timeInterval === "Monthly") {
      fetchInsightTabAPI(getInsightUser, companyInfo?.id, "month", index)
    }
    else if (timeInterval === "Quarterly") {
      fetchInsightTabAPI(getInsightUser, companyInfo?.id, "quarter", `q${index}`)
    }
    else {
      fetchInsightTabAPI(getInsightUser, companyInfo?.id, "year", selectedOption)
    }
  }


  useEffect(() => {
    switch (timeInterval) {
    case "Monthly":
      setFilterOptionsName(monthOption);
      break;
    case "Quarterly":
      setFilterOptionsName(quarterlyOptions);
      break;
    case "Yearly":
      setFilterOptionsName(yearOptions);
      // setFilterOptionsName(yearlyOptions);
      break;
    default:
      setFilterOptionsName([]);
    }
  }, [timeInterval]);

  // let navIndex = companyBrandingDetails?.color_branding?.length > 0 ? companyBrandingDetails?.color_branding.findIndex((data) => data.custom_name === 'side_menu_color') : -1;
  // let getColor = navIndex !== -1 && companyBrandingDetails?.color_branding[navIndex]?.color_code;


  let getColor = "rgba(243, 122, 101, 1)"

  const tabs = [
    { id: 1, label: 'Snapshot' },
    { id: 2, label: 'Analytics' },
    { id: 3, label: 'Insights' },
    { id: 4, label: 'Performance' },
    { id: 5, label: 'Anniversaries' },
    { id: 6, label: 'Library' }
  ];

  const handleComparisonYear = (fromYear, toYear) => {
    getComparisonFromYear(fromYear)
    getComparisonToYear(toYear)
    fetchcompareYearData(toYear, fromYear)
  }
  setShowManageAniBiPopup

  const toggleManageAniBiPopup = () => {
    setShowManageAniBiPopup(!showManageAniBiPopup)
  }


  const checkSign = (input) => {
    if (input > 0) {
      return "plus";
    } else if (input < 0) {
      return "minus";
    }
    return "none";
  }

  const comparisonModal = () => {
    const EngagementEmployeeData = [
      {
        title: "Total Social Posts",
        value: "1",
        img: "/admin-recognition/icons/SocialBox.svg",
        fromCount: compareYearData?.total_social_post?.new_year,
        toCount: compareYearData?.total_social_post?.old_year,
        totalCount: "Posts",
        color: "#DA92C8",
        borderRadius: "11px",
        difference: compareYearData?.total_social_post?.growth,
        differenceType: checkSign(compareYearData?.total_social_post?.growth),
      },
      {
        title: "Recognition Received",
        value: "2",
        img: "/admin-recognition/icons/TotalRecognitionimg.svg",
        fromCount: compareYearData?.total_received_recognition?.new_year,
        toCount: compareYearData?.total_received_recognition?.old_year,
        totalCount: "People Received",
        color: "#91C49D",
        difference: compareYearData?.total_received_recognition?.growth,
        differenceType: checkSign(compareYearData?.total_received_recognition?.growth),
      },
      {
        title: "Recognition Given",
        value: "3",
        img: "/admin-recognition/icons/PeerRecognitionimg.svg",
        fromCount: compareYearData?.total_given_recognition?.new_year,
        toCount: compareYearData?.total_given_recognition?.old_year,
        totalCount: "People Gave",
        color: "#BE7D9C",
        difference: compareYearData?.total_given_recognition?.growth,
        differenceType: checkSign(compareYearData?.total_given_recognition?.growth),

      },
      {
        title: "Exemplifies Company Value",
        value: "4",
        img: "/admin-recognition/icons/Exempifiesimg.svg",
        fromCount: compareYearData?.total_employee_received_recognition?.new_year,
        toCount: compareYearData?.total_employee_received_recognition?.old_year,
        totalCount: "People Exemplified",
        color: "#B1AA56",
        difference: compareYearData?.total_employee_received_recognition?.growth,
        differenceType: checkSign(compareYearData?.total_employee_received_recognition?.growth),
      },
    ];
    return (
      <ComparisonStyledModal
        show={isComparisonModal}
        onHide={manageComparisonPopup}
        dialogClassName="modal-90w"
        style={{ overflowY: 'hidden' }}
        border="1"
      // padding={"16px 24px"}
      >
        <ModalTitle style={{ padding: "16px 24px 0px 24px" }}>
          <div className='title'>Recognition Overview Comparison</div>
          <div className='close' onClick={manageComparisonPopup} >{CloseIconBranding()}</div>
        </ModalTitle>
        <Border margin="16px 0" />
        <Modal.Body style={{ padding: "16px 24px" }} >
          <DropdownHeading>
            <div className='name'>Select oldest year</div>
            <div className='name'>Select newest year</div>
          </DropdownHeading>
          <WrapperYear style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <NewActivityDropdownCommon
              style={{ width: "364px" }}
              border
            >
              <Dropdown.Toggle>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontFamily: "Lato", fontSize: "16px", fontWeight: "400", lineHeight: "20px", color: "#184A61" }}>
                  <div>{comparisonToYear}</div>
                  {yearList?.length > 1 ? <div>
                    {DropdownArrow()}
                  </div> : null}
                </div>
              </Dropdown.Toggle>
              {yearList?.length > 1 ? <Dropdown.Menu>
                {yearList?.map((list, index) => (
                  comparisonFromYear > list &&
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleComparisonYear(comparisonFromYear, list)}
                  >
                    {list}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu> : null}
            </NewActivityDropdownCommon>
            <NewActivityDropdownCommon
              style={{ width: "364px" }}
              border
            >
              <Dropdown.Toggle>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontFamily: "Lato", fontSize: "16px", fontWeight: "400", lineHeight: "20px", color: "#184A61" }}>
                  <div>{comparisonFromYear}</div>
                  {yearList?.length > 1 ? <div>
                    {DropdownArrow()}
                  </div> : null}
                </div>
              </Dropdown.Toggle>
              {yearList?.length > 1 ? <Dropdown.Menu>
                {yearList?.map((list, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={(yearList?.length == index + 1) ? null : () => handleComparisonYear(list, (comparisonToYear < list ? comparisonToYear : yearList[index + 1]))}
                  >
                    {list}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu> : null}
            </NewActivityDropdownCommon>
          </WrapperYear>
          <Border margin="24px 0 12px 0" />
          <div style={{ width: '100%' }}>
            {EngagementEmployeeData.map((item, index) => (
              <YearDataComparisonCard key={index} background={item.color}>
                <div className="image">
                  <img src={ImageUrl + item.img} />
                </div>
                <div className="title">
                  {item.title}
                </div>
                <div className="typeValue">
                  <div className="value">{item.toCount}</div>
                  {/* <div className="type">{item.totalCount}</div> */}
                </div>
                {item.difference == 0 ?
                  <div className="arrows" style={{ justifyContent: "center" }}>
                    <div className={"percentOrange"}>{item.difference}%</div>
                  </div>
                  : <div className="arrows">
                    <img style={{ marginLeft: '5px' }} src={`${ImageUrl}/admin-recognition/${item?.differenceType}.svg`} />
                    {item?.differenceType === "plus" ? <div className={"percent"}>{item.difference}%</div> : <div className={"percentRed"}>{item.difference}%</div>}
                  </div>}
                <div className="newData">
                  {item.fromCount}
                  {/* <div className="type">{item.totalCount}</div> */}
                </div>
              </YearDataComparisonCard>))}
          </div>
        </Modal.Body>
      </ComparisonStyledModal>
    );
  };
  return (
    <>
      <ContainerMain>
        <div className='content-wrap'>
          <BrandingTabContainer isCompare={"0px"}>
            {/* <h2 id="step1">Recognition Admin Dashboard</h2> */}
            {/* <button id="step2">Some Admin Button</button> */}

            
            {showWalkthrough && <Walkthrough setActiveTab={handleTabClick} companyId={companyInfo?.id} showWalkthrough={showWalkthrough} hideProductTour={hideProductTour}/>}
            <div className='wrapper'>
              {tabs.map((tab) => (
                <BrandingTab
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  active={activeTab === tab.id}
                  background={getColor ? getColor : "#0b4170"}
                  id={"step"+tab.id}
                >
                  {tab.label}
                </BrandingTab>
              ))}
            </div>

            {activeTab === 4 || activeTab === 3  ? <div style={{ margin: "0 10px 0 0", cursor: "pointer" }}>
              <HoverButton
                title={"Download"}
                onClick={() =>{
                  activeTab === 4 ? fetchPerformanceReport() : activeTab === 3 ? fetchInsightsReport() : null
                  // ReportsDownloadPopup()
                  // this.printAction(true);
                  
                }}
                marginLeft={"0px"}
                fillOpacity={1}
                activeColor={"#F37A65"}
                inActiveColor={"#F37A65"}
                backgroundColor={"white"}
                backgroundColorActive={"#F37A65"}
                width={"24px"}
                height={"24px"}
                
                svgPath={<DownloadIcon width="24px" height="24px"/>}
              />
            </div>:null}
            {companyInfo?.id === 1 ? <div className='compare'>
              <HoverButton
                title={"Product tour"}
                svgPath={<ProductTourIcon />}
                activeColor={"#F37A65"}
                inActiveColor={"#F37A65"}
                backgroundColor={"white"}
                backgroundColorActive={"#F37A65"}
                onClick={onProductTourClick}
                width={"24px"}
                height={"24px"}
                fillOpacity={1}
              />
            </div> : null}
            <div className='rightSection' id='recognition-comparison'>
              {activeTab === 1 ?
                <div id='snapshot-comparison' className='compare'>
                  <HoverButton
                    title={"Recognition Comparison"}
                    svgPath={<AdminCompareIcon />}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={openComparisonPopup}
                    width={"24px"}
                    height={"24px"}
                    fillOpacity={1}
                  />
                </div> : null
              }
              {activeTab === 5 ?
                <div id="settingSection" className='compare'>
                  <HoverButton
                    title={"Setting"}
                    svgPath={<AdminSettingIcon />}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={() => toggleManageAniBiPopup()}
                    width={"22px"}
                    height={"24px"}
                    fillOpacity={1}
                  />
                </div> : null
              }
              {activeTab === 5 && (departmentDetails.length > 1 || locationDetails.length > 1) ?
                <div className='compare' id="filterSection" style={{ position: "relative" }}>
                  <HoverButton
                    title={"Filter"}
                    svgPath={<AdminFilterIcon />}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    width={"22px"}
                    height={"22px"}
                    fillOpacity={1}
                  />
                  <DeptLoc companyId={companyInfo?.id} fetchCelebrationsDetails={fetchCelebrationsDetails} setIsDropdownOpen={setIsDropdownOpen} isDropdownOpen={isDropdownOpen} activeSubTab={activeSubTab} />
                </div> : null
              }
              {activeTab !== 1 && activeTab !== 6 && DownloadIconHide ?
                <div className='compare'>
                  <HoverButton
                    title={"Download"}
                    svgPath={<AdminDownloadIcon />}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={ReportsDownloadPopup}
                    width={"20px"}
                    height={"24px"}
                    fillOpacity={1}
                  />
                </div> : null
              }
              {activeTab !== 6 && (
                <div style={{ marginLeft: "10px" }} id='yeardropdown'>
                  {activeTab === 1 ? (
                    <CommonFilterDropdown
                      options={yearOptions}
                      selectedOption={selectedYear}
                      setSelectedOption={selectYearData}
                      dropdownHeight={"auto"}
                    />
                  ) : (
                    <div id="yearwise-selection" style={{ display: 'flex', gap: '16px' }}>
                      <CommonFilterDropdown
                        options={filterOptions}
                        selectedOption={timeInterval}
                        setSelectedOption={handleTimeIntervalChange}
                        dropdownHeight={"auto"}
                      />
                      {(activeTab !== 4 && activeTab !== 5) ?
                        <CommonFilterDropdown
                          options={filterOptionsName}
                          selectedOption={monthInterval}
                          setSelectedOption={handleMonthNameChange}
                          dropdownHeight={"auto"}
                        /> : null}
                    </div>
                  )}
                </div>
              )}
              {activeTab == 6 &&
                <div id="core-values" className='compare'>
                  
                  <HoverButton
                    title={"Create Core Value"}
                    svgPath={<AddIconBranding />}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={() => history.push('/company/recognition/core-value/create')}
                    width={"24px"}
                    height={"24px"}
                    fillOpacity={1}
                  /></div>
              }
            </div>
          </BrandingTabContainer>
          {activeTab == 1 && <SnapShot topThree={topThree} topTotal={topTotal} topThreeLocation={topThreeLocation} topTotalLocation={topTotalLocation} selectedYear={selectedYear} companyInfo={companyInfo} topCardsAndGraph={topCardsAndGraph} monthlyBreakDown={monthlyBreakDown} topPerformingEmployee={topPerformingEmployee} topPerformingManager={topPerformingManager} topCardsAndGraphLoader={topCardsAndGraphLoader}/>}
          {activeTab == 2 && <Analyctics getColor={getColor} selectedFilter={timeInterval} companyInfo={companyInfo} monthOption={monthOption} quarterlyOptions={quarterlyOptions} selectedOption={monthInterval} />}
          {activeTab == 3 && <Insights monthOption={monthOption} quarterlyOptions={quarterlyOptions} selectedOption={monthInterval} getColor={getColor} selectedFilter={timeInterval} setInsightUser={setInsightUser} topLowPerformingUsers={topLowPerformingUsers} getRecognitionReceivedUsers={getRecognitionReceivedUsers} geRecognitionGivenUsers={geRecognitionGivenUsers} fetchInsightTabAPI={fetchInsightTabAPI} getInsightUser={getInsightUser} companyId={companyInfo?.id} selectedYear={selectedYear} getRecognitionOverview={getRecognitionOverview} setPageNumberPaginationReceived={setPageNumberPaginationReceived} pageNumberReceived={pageNumberReceived} getRecognitionReceivedUsersData={getRecognitionReceivedUsersData} geRecognitionGivenUsersData={geRecognitionGivenUsersData} pageNumberGiven={pageNumberGiven} setPageNumberPaginationGiver={setPageNumberPaginationGiver} setPageNumberReceived={setPageNumberReceived} setPageNumberGiven={setPageNumberGiven} />}
          {activeTab == 4 && <Performance selectedFilter={timeInterval} getColor={getColor} companyInfo={companyInfo} />}
          {isComparisonModal && comparisonModal()}
          {activeTab == 5 && <Anniversaries anniversaryData={anniversaryData} activeSubTab={activeSubTab} setActiveSubTab={setActiveSubTab} getColor={getColor} companyInfo={companyInfo} selectedFilter={timeInterval} />}
          {activeTab == 6 && <Library activeTab={activeTab} getColor={getColor} history={history} companyInfo={companyInfo} />}
          <DownloadReportsModal
            show={isReportsDownloadModal}
            onClose={ReportsDownloadPopup} />

          {showManageAniBiPopup && (
            <ManageAniBiPopup
              showModal={ManageAniBiPopup}
              // detailInitiative={selectedCoreValue}
              onClose={() => setShowManageAniBiPopup(false)}
              companyId={companyInfo?.id}
            />
          )}
        </div>
      </ContainerMain>
    </>
  );
};

RecognitionMain.propTypes = {
  companyInfo: PropTypes.object.isRequired,
  companyId: PropTypes.number,
  companyBrandingDetails: PropTypes.object,
  yearList: PropTypes.array,
  history: PropTypes.object,
  departmentDetails:PropTypes.array, 
  locationDetails:PropTypes.array,
  productTourDetails:PropTypes.object,
  companyDetails: PropTypes.object,
};

const mapStateToProps = (state) => ({
  companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  productTourDetails: state.profileData.productTourDetails,
  companyDetails: state.profileData.companyDetails,

});

export default connect(mapStateToProps, null)(RecognitionMain);